import { IComponentOptions } from 'angular';
import { StudentCreditGapsPanelCurrentProgramCtrl } from './student-credit-gaps-panel-current-program.controller';

export const studentCreditGapsPanelCurrentProgramComponent: IComponentOptions = {
  template: require('./student-credit-gaps-panel-current-program.html'),
  bindings: {
    student: '=',
    school: '<',
    studentDiffs: '=',
    studentGapPlans: '<',
    isRestricted: '<',
  },
  controller: StudentCreditGapsPanelCurrentProgramCtrl,
};
